import { Root } from "mdast";
import { Plugin } from "unified";
import {
  createCustomElement,
  createTextVisitor,
  processTextWithRegex,
  ReplacementResult,
} from "../react-markdown-registry/utils";

export interface RemarkExcerptProps {
  text: string;
}

/**
 * This plugin is used to convert excerpt indicators for ask paper into an excerpt element.
 */
export const remarkExcerpt: Plugin<[], Root> = () => {
  return (tree: Root) => {
    const visitText = createTextVisitor();

    visitText(tree, (node, index, parent) => {
      return processTextWithRegex(
        node,
        index,
        parent,
        /\{\{(.*?)\}\}/g,
        (match): ReplacementResult => {
          const [, excerpt] = match;
          return {
            node: createCustomElement<RemarkExcerptProps>("excerpt", {
              text: excerpt,
            }),
          };
        }
      );
    });
  };
};
